import { useState, useEffect, useRef } from 'react';

const useLiveTracking = () => {
  const [liveLocations, setLiveLocations] = useState([]);
  const [userLocation, setUserLocation] = useState(null);
  const [isTracking, setIsTracking] = useState(false);
  const watchId = useRef(null);
  const ws = useRef(null);
  console.log("🚀 ~ useLiveTracking ~ ws:", ws)

  // Get user's current location
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      console.error('Geolocation not supported');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          timestamp: Date.now()
        };
        setUserLocation(location);
      },
      (error) => console.error('Location error:', error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  };

  // Start live tracking
  const startTracking = () => {
    if (!navigator.geolocation) return;

    setIsTracking(true);
    watchId.current = navigator.geolocation.watchPosition(
      (position) => {
        const location = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          timestamp: Date.now()
        };
        setUserLocation(location);
        
        // Send to server (demo with fetch)
        sendLocationUpdate(location);
      },
      (error) => console.error('Tracking error:', error),
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  };

  // Stop tracking
  const stopTracking = () => {
    if (watchId.current) {
      navigator.geolocation.clearWatch(watchId.current);
      watchId.current = null;
    }
    setIsTracking(false);
  };

  // Send location update (demo)
  const sendLocationUpdate = async (location) => {
    try {
      // Replace with your API endpoint
      await fetch('/api/location/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: 'demo-user',
          ...location
        })
      });
    } catch (error) {
      console.error('Failed to send location:', error);
    }
  };

  // Simulate live locations (demo)
  useEffect(() => {
    const interval = setInterval(() => {
      // Demo: Generate random locations around London
      const demoLocations = [
        {
          id: 'user1',
          name: 'Inspector John',
          latitude: 51.5074 + (Math.random() - 0.5) * 0.01,
          longitude: -0.1278 + (Math.random() - 0.5) * 0.01,
          lastUpdate: Date.now(),
          status: 'active'
        },
        {
          id: 'user2', 
          name: 'Manager Sarah',
          latitude: 51.5074 + (Math.random() - 0.5) * 0.01,
          longitude: -0.1278 + (Math.random() - 0.5) * 0.01,
          lastUpdate: Date.now(),
          status: 'active'
        }
      ];
      setLiveLocations(demoLocations);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return {
    liveLocations,
    userLocation,
    isTracking,
    getCurrentLocation,
    startTracking,
    stopTracking
  };
};

export default useLiveTracking;